import { QuoteHeader } from '@quorum/models/xs-resource';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface QuotesState extends EntityState<QuoteHeader> {}

export const quotesAdapter: EntityAdapter<QuoteHeader> = createEntityAdapter<QuoteHeader>({
  selectId: (quote: QuoteHeader) => quote.id
});

export const initialState: QuotesState = quotesAdapter.getInitialState({});
export const workOrdersFeatureSelector = createFeatureSelector<any>('fixedOperations');
export const quotesSelector = createSelector(
  workOrdersFeatureSelector,
  (state: any) => state.quotes
);
export const { selectIds, selectEntities, selectAll, selectTotal } = quotesAdapter.getSelectors(quotesSelector);
